import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class ScrollImages {
  constructor(el) {
    this.dom = {el: el};
    this.dom.target = this.dom.el.querySelector('[data-js="images-lists"]');
    this.dom.wrapper = document.querySelector('.hm-images__inner');

    gsap.registerPlugin(ScrollTrigger);

    this.adj = 4;

    // 画像を並べている要素のサイズ
    this.container = {
      // w: 2864,
      // h: 2135,
      w: 1260,
      h: 939.28
    }
    this.containerAspect = this.container.h / this.container.w;
    // console.log('this.containerAspect', this.containerAspect)

    // 全画面に表示する画像
    this.image = {
      w: 554,
      h: 317
    }
    this.imageAspect = this.image.h / this.image.w;
    
    // windowサイズ
    this.sizes = {
      w: window.innerWidth,
      h: window.innerHeight,
    }
    this.windowAspect = this.sizes.h / this.sizes.w;
    // console.log('this.windowAspect', this.windowAspect)

    this.topAspect = 0;
    this.scaleY = 0;
    this.setY = 0;
    this.toScale = 0;
    this.toY = 0;

    this.setSizes = this.setSizes.bind(this);

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);

    this.init();
  }

  init() {
    // ブレイクポイントの瞬間に発火
    this.mql.addListener(this.checkBreakPoint);
    // 初回チェック
    this.checkBreakPoint(this.mql);
  }

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');
      gsap.to(this.dom.target, {
        scale: 1
      })
  
      return;
    } else {
      // console.log('pc');

      this.setSizes();
      window.addEventListener('resize', this.setSizes);

      gsap.set(this.dom.wrapper, {
        height: (this.sizes.w * this.containerAspect) * 2 + 'px'
      });

      gsap.set(this.dom.el, {
        height: ((this.sizes.w * this.containerAspect)) * 1 + 'px'
      });

      // console.log('this.topAspect', this.topAspect)

      gsap.set(this.dom.target, {
        width: this.scaleW * this.container.w,
        x: '-50%',
        y: this.setY
      });

      gsap.to(this.dom.target, {
        scale: this.toScale,
        y: 0,
        duration: 2,
        easing: 'linear',
        scrollTrigger: {
          trigger: this.dom.el,
          start: 'top 0%',
          end: 'bottom 100%',
          toggleActions: 'play pause resume reset',
          markers: false,
          id: 'endless',
          // scrub: true,
          scrub: this.adj // smoothing
        }
      })
      return;
		}
	}

  setSizes() {
    this.sizes = {
      w: window.innerWidth,
      h: window.innerHeight,
    }
    this.topAspect = this.sizes.h / this.image.h;
    this.scaleW = (this.imageAspect < this.windowAspect) ? this.sizes.h / this.image.h : this.sizes.w / this.image.w;
    this.scaleY = this.sizes.h / this.image.h;
    this.setY = ((-122.734 / this.container.h) * 100) + '%';
    this.toScale = this.sizes.w / (this.scaleW * this.container.w);
    this.toY = (this.adj * this.container.h) - this.container.h;
  }
}

export default ScrollImages